import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';

class Import extends React.Component {
  static propTypes = {
    onImport: PropTypes.func.isRequired
  }

  state = {
    data: '',
    error: '',
    importing: false
  }

  showModal = () => {
    this.setState({ importing: true });
  }

  handleEnter = () => {
    this.setState({
      data: '',
      error: ''
    });
  }

  handleChange = (event) => {
    this.setState({
      data: event.target.value,
      error: ''
    });
  }

  handleImport = () => {
    try {
      const options = JSON.parse(this.state.data);
      this.props.onImport(options);
      this.setState({ importing: false });
    } catch (error) {
      this.setState({ error: `Could not import: ${error.message}` });
    }
  }

  handleHide = () => {
    this.setState({ importing: false });
  }

  render() {
    const { onImport, ...props } = this.props;

    return (
      <React.Fragment>
        <button {...props} name="import" onClick={this.showModal}>
          Import
        </button>

        {this.renderModal()}
      </React.Fragment>
    );
  }

  renderModal() {
    return (
      <Modal
        className="email-option-import-modal"
        show={this.state.importing}
        onEnter={this.handleEnter}
        onHide={this.handleHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>Import Options</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Paste exported options below:
          <textarea value={this.state.data} onChange={this.handleChange} />
        </Modal.Body>

        <Modal.Footer>
          <span className="error text-danger">{this.state.error}</span>

          <div>
            <button className="btn btn-default" name="cancel" onClick={this.handleHide}>
              Cancel
            </button>

            <button className="btn btn-primary" name="import-data" onClick={this.handleImport}>
              Import
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default Import;
